import { Grid, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

import shortLogo from "@/assets/images/vector_logo_4_short.svg";
import { classes } from "@/utils/css";

import styles from "./AppLoader.module.css";

export type AppLoaderProps = {
  style?: React.CSSProperties;
  color?: string;
  hideText?: boolean;
};

function AppLoader(props: AppLoaderProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={styles.loadingContainer}
      style={{ height: "100%", ...props.style }}
    >
      <Grid
        container
        direction="column"
        alignItems="center"
        className={styles.loadingPaper}
      >
        <img src={shortLogo} className={classes(styles.loading)} />
        {!props.hideText && (
          <Typography variant="body2" className={styles.loadingText} mt={1}>
            {t("Loading")}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
}

export default AppLoader;
